import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'
import axios from 'axios'

export interface OAuthRefreshTokenRequest {
  baseURL: string
  refreshToken: string
  clientId: string
}

export async function refreshOAuthToken({
  baseURL,
  refreshToken,
  clientId,
}: OAuthRefreshTokenRequest) {
  const response = await axios.post(
    `${baseURL}/api/server/oauth2/token`,
    new URLSearchParams({
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
      client_id: clientId,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      _skipGlobalError: true,
    }
  )

  return response.data
}

export async function refreshWebSession(baseURL: string) {
  const response = await axios.post(
    `${baseURL}/api/client/refresh`,
    {},
    {
      withCredentials: true,
      _skipGlobalError: true,
    }
  )

  return response.data
}

export async function tokenService(baseURL: string) {
  if (Capacitor.isNativePlatform()) {
    const { value: refreshToken } = await Preferences.get({ key: 'refresh_token' })

    if (!refreshToken) {
      throw new Error('No refresh token found')
    }

    return refreshOAuthToken({
      baseURL,
      refreshToken,
      clientId: 'app-client',
    })
  }

  return refreshWebSession(baseURL)
}
